import logErrors from '@nykaa/logger/logErrors';
import { standardErrorMessages } from '@nykaa/utils/logging/constants';
import { ApiHelper } from '@nykaa/utils/network';
import { getUrl, ROUTES } from '@nykaa/utils/network/urls';
import { defaultQueryParams } from '@nykaa/cart-shared/store/constants';
import { CartDataParams } from 'hooks/cart/useGetCartData';
import { CART_LITE_API } from 'store/addToCart/constants';

export const getConvenienceFeeHeader = (
  enabled?: boolean
): { [key: string]: string } =>
  enabled ? { 'X-APPLY-CART-CHARGES': 'true' } : {};

export const cartLiteRefresh = async (
  params: CartDataParams,
  convenienceChargesEnabled?: boolean
) => {
  const url = `${getUrl(ROUTES.GATEWAY)}${CART_LITE_API}`;
  const { headers, ...bodyFields } = params || ({} as CartDataParams);
  const postData = {
    ...defaultQueryParams,
    ...bodyFields,
  };
  const header = {
    ...getConvenienceFeeHeader(convenienceChargesEnabled),
    ...(headers || {}),
  };

  try {
    const {
      data: { success, data: apiData, message, statusCode },
    } = await ApiHelper(
      `${url}`,
      'post',
      postData,
      header as { [key: string]: string }
    );

    if (!success) {
      return Promise.reject({
        errorInApi: true,
        message: message || standardErrorMessages.SOMETHING_WRONG,
        statusCode,
      });
    }
    return apiData;
  } catch (e) {
    logErrors(e, 'Error in cart refresh lite api');
    throw e;
  }
};
